import React from 'react'

import { Icon, ArrowRight } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { string } from 'prop-types'

const ARROW_SIZE = { width: '18', height: '18' }

// "Browse all 3D Models ->" row. Mobile-only (the `__browse` class hides it at md+,
// where the footer CTA covers the same action). Rendered both as the panel's top row
// in the default state and pinned at the top of the mobile subcategory drill-in, so it
// stays visible while a category is open (matching the Figma mobile flows).
function BrowseAllRow({ href, label }) {
  return (
    <a href={href} className="category-mega-menu__browse cgt-button-text-md-semibold">
      <span className="category-mega-menu__browse-label">{label}</span>
      <Icon notSpaced color="dark" size={ARROW_SIZE} svgComponent={ArrowRight} />
    </a>
  )
}

BrowseAllRow.propTypes = {
  href: string.isRequired,
  label: string.isRequired,
}

export default BrowseAllRow
